export default function nextMatches(api) {
    return api && api.provideCall && api.provideCall('requestNextMatches', 'cancelNextMatchesRequest', {
        // topic to request
        rpcName: '/sports#nextMatches',

        parseParams: ({ lang = 'en', disciplineId = '1', hoursTillLive = 24 }) => ({ lang, disciplineId, hoursTillLive }),

        // validation occurs before parsing
        validateResponse: (data) => !data || data && data.kwargs,
        parseResponse: data => (!data && []) || (data.kwargs && data.kwargs.records) || (data && data.kwargs),
    });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/rpc-next-matches.js